// src/pages/CSKTeam/Tabs.tsx
import React from "react";
import styles from "./Tabs.module.scss";

interface TabsProps {
    tabs: string[];
    activeTab: string;
    onTabChange: (tab: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange }) => {
    const theme = localStorage.getItem("theme");

    return (
        <div className={styles.tabs} data-theme={theme}>
            {tabs.map((tab) => (
                <button
                    key={tab}
                    className={`${styles.tab} ${
                        activeTab === tab ? styles.active : ""
                    }`}
                    onClick={() => onTabChange(tab)}
                    data-theme={theme}
                >
                    {tab}
                </button>
            ))}
        </div>
    );
};

export default Tabs;
